import ProductData from '../../model/product-data';
import QuantitySelector from '../inputs/quantity-selector';
import AsyncPrices from './async-prices';
import AsyncStock from './async-stock';
import { getParameterByName } from '../../helpers/utils';

const selectors = {
  container: '.js-matchingTires',
  content: '.js-content',
  toggle: '.js-toggle',
};

export default class MatchingTires {
  private static ENDPOINT = '/products/tire-match';
  private static VIEW_ENDPOINT = '/products/tire-match-view';
  private readonly productCode: string;
  private matchingTires: ProductData[] = [];
  private contentContainer: HTMLDivElement;
  private isLoading =false;
  private isLoaded = false;

  constructor(private container: HTMLDivElement) {
    this.productCode = container.dataset.code as string;
    this.contentContainer = container.querySelector<HTMLDivElement>(selectors.content) as HTMLDivElement;
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    container.querySelector(selectors.toggle)?.addEventListener('click', () => this.toggle());
  }

  static initAll(): MatchingTires[] {
    return Array.from(document.querySelectorAll<HTMLDivElement>(selectors.container))
      .map((element) => new MatchingTires(element));
  }

  async toggle(): Promise<void> {
    this.container.classList.toggle('-expanded');
    if (this.container.classList.contains('-expanded') && !this.isLoadedOrLoading()) {
      this.render(await this.fetchMatchingTiresView());
      this.isLoaded = true;
    }
  }

  private isLoadedOrLoading(): boolean {
    return this.isLoaded || this.isLoading;
  }

  private async fetchMatchingTiresView(): Promise<string> {
    try {
      this.isLoading = true;

      const endpoint = new URL(`${window.location.origin}${MatchingTires.VIEW_ENDPOINT}?code=${this.productCode}`);
      const stockLevel = getParameterByName('stockLevel');
      if (stockLevel) {
        endpoint.searchParams.set('stockLevel', stockLevel);
      }

      const response = await fetch(endpoint.toString());
      return await response.text();
    } catch {
      throw new Error(`Could not fetch matching tyres for ${this.productCode}`);
    } finally {
      this.isLoading = false;
    }
  }

  render(content: string): void {
    this.contentContainer.innerHTML = content;
    const $contentContainer = $(this.container.querySelector(selectors.content) as HTMLDivElement);
    QuantitySelector.initAll($contentContainer);
    AsyncPrices.init($contentContainer);
    AsyncStock.init($contentContainer);
  }
}
